module.exports = __webpack_public_path__ + "build/desktop/img/meal.1507158bd7e2f542b8d224b20bc72ae8.svg";